export default "__VITE_ASSET__fa482503__"